// Generated by Melange

import * as Buhta_cabinet__Button from "../html/Button.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function AddItemButton(Props) {
  let className = Props.className;
  let onClick = Props.onClick;
  let children = Props.children;
  let tmp = {
    size: "s",
    onClick: onClick,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("img", {
          src: StaticAsset.src("/static/icons/plus.svg")
        }),
        JsxRuntime.jsx("div", {
          children: children,
          className: "ml-2"
        })
      ],
      className: "btn-content flex items-center"
    })
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return JsxRuntime.jsx(Buhta_cabinet__Button.make, tmp);
}

const make = AddItemButton;

export {
  make,
}
/* Buhta_cabinet__Button Not a pure module */
